import { ArticleContainer } from '@3d-scene/model3d/article-container';

export class ArticleProjectData {
  public articleContainers: ArticleContainer[] = [];
}
